import EmbeddingsConstants from "../../../../embeddings/constants";

namespace EmbeddingProcessStatesConstants {
  export const MAX_PAYLOAD_LENGTH = EmbeddingsConstants.MAX_EMBEDDING_MODEL_ID_LENGTH + 1000;
}

export default EmbeddingProcessStatesConstants;
